module.exports = __webpack_public_path__ + "media/images/sport--Para_Biathlon-744fb6edea86bbc74f5a7bcca40d18e7.png";